module.exports = __webpack_public_path__ + "static/img/edit.4e131410.png";